import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { Button, Field, TextField, Layout as MLayout } from '@loadsmart/miranda-react'
import * as Yup from 'yup'

import { ContentContainer } from '../../components/ContentContainer'
import { Logo } from '../../components/Icon/SVG/index'
import { Layout } from '../../components/Layout'
import { PageBody } from '../../components/PageBody'
import { PAGE_PATHS } from '../../config/pagePaths'
import { useAuthentication } from '../../hooks/useAuthentication'
import { useMessage } from '../../hooks/useMessage'
import { SPACING } from '../../styles/mixins/constants'
import { device } from '../../styles/mixins/device'
import { Form, Formik, FormikProps } from 'formik'

const StyledForm = styled(Form)`
  width: 100%;
`

const Container = styled(PageBody)`
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;
  min-height: 0px;
  flex: 1 1 auto;
`

const Content = styled(ContentContainer)`
  flex-flow: column nowrap;
  width: 100%;
  max-width: 300px;
  flex: 0 1 auto;
  min-height: 0px;
  min-width: 0px;
  margin: 0 ${SPACING[2]};
  padding: ${SPACING[6]};
  align-items: center;
  ${device.tablet`
    max-width: 400px;
  `}
`

const LogoContainer = styled.div`
  height: 75px;
  svg {
    height: 100%;
  }
`

const StyledButton = styled(Button)`
  width: 100%;
`

const validationSchema = Yup.object().shape({
  email: Yup.string().email().required(),
  password: Yup.string().required(),
})

export function Auth(): JSX.Element {
  const { login, isLoading } = useAuthentication()

  const initialValues = {
    email: '',
    password: '',
  }

  const messenger = useMessage()
  const navigate = useNavigate()

  const handleSubmit = async ({ email, password }): Promise<void> => {
    try {
      await login({ email, password })
      navigate(PAGE_PATHS.gateFeed)
    } catch (e) {
      messenger.error(e)
    }
  }

  return (
    <Layout>
      <Container>
        <Content>
          <LogoContainer>
            <Logo />
          </LogoContainer>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
          >
            {({
              handleChange,
              values,
              errors,
            }: FormikProps<{ email: string; password: string }>) => {
              return (
                <StyledForm id="login-form">
                  <MLayout.Stack>
                    <Field status={errors.email ? 'danger' : 'default'}>
                      <Field.Label>Email</Field.Label>
                      <TextField
                        name="email"
                        type="email"
                        onChange={handleChange}
                        value={values.email}
                      />
                    </Field>
                    <Field status={errors.password ? 'danger' : 'default'}>
                      <Field.Label>Password</Field.Label>
                      <TextField
                        name="password"
                        type="password"
                        onChange={handleChange}
                        value={values.password}
                      />
                    </Field>
                    <StyledButton type="submit" size="large" loading={isLoading} variant="primary">
                      Login
                    </StyledButton>
                  </MLayout.Stack>
                </StyledForm>
              )
            }}
          </Formik>
        </Content>
      </Container>
    </Layout>
  )
}
